import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

import close_img from '../../../assets/images/close.svg'

import '../../../components/_modals/modalStyle.css'
import VideoUploader from '../../../features/VideoUploader/VideoUploader';
import FileUploader from '../../../features/FileUploader/FileUploader';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchAddLink, fetchAddVideosToFolder } from '../FolderApi';

import  Form from 'react-bootstrap/Form';
import  Modal from 'react-bootstrap/Modal';
import  Tabs from 'react-bootstrap/Tabs';
import  Tab from 'react-bootstrap/Tab';
import { loadOperations } from "../../../services/global/globalSlice";
import { v4 as uuidv4 } from 'uuid';

const detectFiletype = (url) => {
    try {
        const cleanUrl = url.split('?')[0].split('#')[0]
        const match = cleanUrl.match(/\.([a-zA-Z0-9]{2,5})$/)
        return match ? match[1].toLowerCase() : 'mp4'
    } catch (e) {
        return 'mp4'
    }
}

export default function ContentCreateModal(props)  {
    const {show, type, onClose, folderData} = props
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [linkData, setLinkData] = useState({
        link_url: "",
        name: ""
    })

    const [externalVideoData, setExternalVideoData] = useState({
        name: "",
        video_url: "",
        poster_image_url: ""
    })

    const handleInputChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        setLinkData({
            ...linkData,
            [name]: value
        })
    }

    const handleExternalVideoChange = (e) => {
        const target = e.target
        setExternalVideoData({
            ...externalVideoData,
            [target.name]: target.value
        })
    }

    const handleAddLink = async () => {
        if(linkData.link_url && linkData.name){
            const response = await fetchAddLink({folder_id: folderData.folder_id}, [...folderData.links || [], linkData])
            if(response.success){
                toast.success(t.materials.link_added)
                props.onClose()
            } else {
                toast.error(t.materials.link_error)
            }
        } else {
            toast.error(t.materials.missing_link_data)
        }
    }

    const handleAddExternalVideo = async () => {
        if(!externalVideoData.name || !externalVideoData.video_url){
            toast.error(t.materials.missing_external_video_data)
            return
        }
        const payload = [{
            video_type: "external",
            poster_image_url: externalVideoData.poster_image_url || "",
            name: externalVideoData.name,
            video_url: externalVideoData.video_url
        }]
        const response = await fetchAddVideosToFolder({folder_id: folderData.folder_id}, payload)
        if(response.success){
            toast.success(t.materials.external_video_added)
            dispatch(loadOperations())
            props.onClose()
        } else {
            toast.error(t.materials.external_video_error)
        }
    }

    const logUpload = (e) => {
        console.log(e);
        console.log('video uploaded');
        dispatch(loadOperations())
    }

    useEffect(()=>{
        setLinkData({
            name: "",
            link_url: ""
        })
        setExternalVideoData({
            name: "",
            video_url: "",
            poster_image_url: ""
        })
    },[show])

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
        >
            <Modal.Body>
                <div className='d-flex align-items-center justify-content-between'>
                    <h2 className="text-center">{t.folder.add} {t.folder[type]}</h2>
                    <img src={close_img} alt='' onClick={onClose} />
                </div>
                {
                    type === 'video' && <>
                        <Tabs defaultActiveKey="upload" id="video-source-tabs" className="mt-3 mb-3">
                            <Tab eventKey="upload" title={t.materials.upload_video}>
                                <VideoUploader folderId={folderData.folder_id} onUpload={logUpload} onUploadEnd={props.onClose} />
                            </Tab>
                            <Tab eventKey="external" title={t.materials.external_video}>
                                <Form.Group controlId="external_video_name" className='mt-2'>
                                    <Form.Label>{t.materials.video_name}*</Form.Label>
                                    <Form.Control type="text" value={externalVideoData.name} name="name" onChange={handleExternalVideoChange} />
                                </Form.Group>
                                <Form.Group controlId="external_video_url" className='mt-2'>
                                    <Form.Label>{t.materials.video_url}*</Form.Label>
                                    <Form.Control type="url" value={externalVideoData.video_url} name="video_url" placeholder={'https://...'} onChange={handleExternalVideoChange} />
                                </Form.Group>
                                <Form.Group controlId="external_video_poster" className='mt-2'>
                                    <Form.Label>{t.materials.poster_image_url}</Form.Label>
                                    <Form.Control type="url" value={externalVideoData.poster_image_url} name="poster_image_url" placeholder={'https://...'} onChange={handleExternalVideoChange} />
                                </Form.Group>
                                <button className="mt-3 mx-auto" onClick={handleAddExternalVideo}>{t.folder.add}</button>
                            </Tab>
                        </Tabs>
                    </>
                }
                {
                    type === 'file' && <>
                        <FileUploader folderId={folderData.folder_id} onUpload={logUpload} onUploadEnd={props.onClose} />
                    </>
                }
                {
                    type === 'link' && <>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.link_name}*</Form.Label>
                            <Form.Control type="text" value={linkData.name} name="name" onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.link}*</Form.Label>
                            <Form.Control type="url" value={linkData.link_url} name="link_url" placeholder={'https://...'} onChange={handleInputChange} />
                        </Form.Group>
                        <button className="mt-2 mx-auto" onClick={handleAddLink} >{t.folder.add}</button>
                    </>
                }
            </Modal.Body>
        </Modal>
    )
}
